module.exports = __webpack_public_path__ + "img/account.5dd49dcd.svg";